<template>
  <form @submit.prevent="onSubmit" class="clm-form__form">
    <a-layout :line-type="'create'" @go="goCreate" :title-text="$t('auth-form-auth.titleText')" @close="$emit('close')">

      <a-report :is-error="true" v-if="serverError">
        Внимание! {{serverError}}
      </a-report>
      <div class="clm-form__inputs-block">
        <auth-form-input
            @submit="onSubmit"
            :is-requared="true"
            :id="idPrefix + 'af-email'"
            :input-type="'email'"
            :input-name="'login'"
            :class-name="'email'"
            :placeholder="'youremailadress@mail.ru'"
            :err-msg="(formEmail.length > 0) ? $t('auth-form-auth.errorEmailFormat') : $t('auth-form-auth.errorEmailEmpty')"
            :is-valid="cFromEmailValid"
            :is-invalid="formEmailInvalid"
            v-model="formEmail"
        >{{$t('auth-form-auth.labelEmail')}}
        </auth-form-input>
        <auth-form-input
            @submit="onSubmit"
            :is-requared="true"
            :id="idPrefix + 'af-pass'"
            :input-type="(showPassword) ? 'text' : 'password'"
            :input-name="'password'"
            :class-name="'password'"
            :placeholder="$t('auth-form-auth.placeholderPass')"
            :err-msg="cPassErr"
            :is-valid="cFromPassValid"
            :is-invalid="formPassInvalid"
            :show-pass-btn="true"
            :show-pass-recovery="true"
            :is-visible="showPassword"
            @recovery="goRecovery"
            @pass:show="showPassword = true"
            @pass:hide="showPassword = false"
            v-model="formPass"
        >{{$t('auth-form-auth.labelPass')}}
        </auth-form-input>
      </div>
      <div class="clm-form-btns">
        <a-submit-btn :is-disabled="!cFormValid" @action="onSubmit" :is-loading="formProcess">{{$t('auth-form-auth.submitText')}}</a-submit-btn>
      </div>
      <a-agreement>{{$t('auth-form-auth.submitText')}}</a-agreement>

    </a-layout>
  </form>
</template>

<script>
import aReport from './a-report.vue'
import authFormInput from "../auth-form-input.vue"
import aAgreement from './a-agreement.vue'
import aSubmitBtn from './a-submit-btn.vue'

import aLayout from './a-layout.vue'

import validate from '../../../scripts/validate'
import declOfNum from "../../../scripts/declOfNum";

export default {
  name: "auth-form-auth",
  components: {
    aReport,
    aAgreement,
    aSubmitBtn,
    authFormInput,
    aLayout
  },
  props: {
    idPrefix: String,
    pageParams: Object,
    newPassStart: [String, Boolean],
  },
  emits: ['close', 'go:create', 'go:recovery'],
  data() {
    return {



      formEmail: '',
      formEmailInvalid: false,
      formPass: '',
      formPassInvalid: false,

      showPassword: false,

      formProcess: false,
      serverError: false,
      defaultErr: 'Ошибка в работе сайта. Попробуйте еще раз.'
    }
  },
  computed: {
    cFromEmailValid() {
      return validate('email', this.formEmail)
    },
    cFromPassValid() {
      return (this.formPass.length >= this.pageParams.passPolicy.PASSWORD_LENGTH)
    },
    cFormValid() {
      return (this.cFromEmailValid && this.cFromPassValid)
    },
    cPassErr() {
      const min = this.pageParams.passPolicy.PASSWORD_LENGTH;
      if (this.formPass.length > 0) {
        return this.$t('auth-form-auth.errorEmailFormat') + min + ' ' + declOfNum(min, [this.$t('auth-form-auth.symbol0'), this.$t('auth-form-auth.symbol1'), this.$t('auth-form-auth.symbol2')])
      } else {
        return this.$t('auth-form-auth.errorPassEmpty')
      }
    }
  },
  created() {
    if (this.newPassStart) {
      this.formEmail = this.newPassStart;
    }
  },
  watch: {
    formEmail() {
      this.formEmailInvalid = false;
    },
    formPass() {
      this.formPassInvalid = false;
    },
  },
  methods: {
    goRecovery() {
      const email = this.formEmail;
      const text = (validate('email', email)) ? email : false;
      this.$emit('go:recovery', text)
    },
    goCreate() {
      this.$emit('go:create')
    },
    onSubmit() {
      if (this.formProcess) {
        return null;
      }

      const props = [
        {name: 'formEmail', type: 'email'},
      ]
      let noErr = true
      props.forEach(el => {
        if (!validate(el.type, this[el.name])) {
          this[el.name + 'Invalid'] = true;
          noErr = false;
        }
      })
      if (this.formPass.length < this.pageParams.passPolicy.PASSWORD_LENGTH) {
        noErr = false;
        this.formPassInvalid = true;
      }

      if (noErr) {
        this.formProcess = true;
        this.$api.auth({
          'USER_LOGIN': this.formEmail,
          'USER_PASSWORD': this.formPass,
        }).then(data => {
          const defaultRedirect = '/dashboard'
          console.log(data)
          if (typeof data.data === 'string') {
            if ('request' in data && 'responseURL' in data.request && data.request.responseURL) {
              window.location.assign(data.request.responseURL);
            } else {
              window.location.assign(defaultRedirect);
            }
            this.serverError = false;
            this.formProcess = false;
            return null;
          }
          const response = data.data;
          if (response.status) {
            if ('data' in response && 'REDIRECT' in response.data && response.data.REDIRECT.length > 0) {
              window.location.assign(response.data.REDIRECT);
            } else {
              window.location.assign(defaultRedirect);
            }
            this.serverError = false;
          } else {
            if (response.errors.length > 0) {
              this.serverError = response.errors.join('; ')
            } else {
              this.serverError = this.defaultErr
            }
          }
          this.formProcess = false;
        }).catch(err => {
          console.error('Ajax err')
          console.log(err)
          this.serverError = this.defaultErr
          this.formProcess = false;
        })
      }
    }
  }
}
</script>
